import axios from "axios";

export const servicesData = () => {
    return axios
      .get("/our-services")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };